export const TYPE_DOCUMENTS = [
  { key: 'scientific_article', value: 'Научная статья' },
  { key: 'project', value: 'Проект' },
];
